export default "__VITE_ASSET__BIioV4DN__"